
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";

interface LocationCTAProps {
  locationName: string;
  ctaTitle?: string;
  ctaDescription?: string;
}

const LocationCTA: React.FC<LocationCTAProps> = ({ 
  locationName,
  ctaTitle,
  ctaDescription
}) => {
  const defaultTitle = `Kom i gang med klaverundervisning i ${locationName}`;
  const defaultDescription = `Book en gratis prøvetime og start din rejse med professionel klaverundervisning fra Oscar Gilbert i ${locationName}.`;
  
  return (
    <section className="py-16 bg-piano-black text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-serif font-bold mb-6">{ctaTitle || defaultTitle}</h2>
        <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
          {ctaDescription || defaultDescription}
        </p>
        <Button asChild size="lg" className="bg-piano-gold hover:bg-piano-gold/90 text-white">
          <Link to="/kontakt">Book gratis prøvetime</Link>
        </Button>
      </div>
    </section>
  );
};

export default LocationCTA;
